// Internal API
export const INTERNAL_API_PREFIX = '/api/'

// Translator key prefix
export const T_SERVER_ERROR_PREFIX = 'SERVER_ERROR_'

export const HEADER_X_WWW_AUTHENTICATE = 'x-www-authenticate'

// Headers to serialize
export const HEADERS_TO_SERIALIZE = [
    'content-type',
    'content-encoding',
    'content-length',
    'x-auth-token',
    HEADER_X_WWW_AUTHENTICATE
]

export const ERROR_ITEM_FETCHED = 'fetched'

// -------------------------------------------------------------------

// The data (if set) is from a previous session
export const STATUS_REHYDRATED = 'REHYDRATED'
// Require data, fetch if not yet fetched
export const STATUS_REQUIRE = 'REQUIRE'
// Force the fetch of new data
export const STATUS_FETCH = 'FETCH'
export const STATUS_FETCHING = 'FETCHING'
export const STATUS_FETCHED = 'FETCHED'
export const STATUS_UNAUTHORIZED = 'UNAUTHORIZED'
export const STATUS_ERROR = 'ERROR'

// -------------------------------------------------------------------
